import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { FcSurvey, FcVoicePresentation } from "react-icons/fc";
import {
  MdArrowForwardIos,
  MdClose,
  MdKeyboardArrowLeft,
} from "react-icons/md";
import { RequestContext } from "../../../context/request.context";
import { useContext, useState } from "react";
import Trades from "../../trades/trade";
import numberFormat from "../../../components/globalFunction/prettierNumber";

const ManagerComponent = ({ index, data, action, routes, times }) => {
  const { request } = useContext(RequestContext);
  const [dialog, setDialog] = useState({
    open: false,
    data: [],
    manager: null,
  });

  const calculateTotalPrice = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      e.products.forEach((e) => {
        total += e.amount * e.price;
      });
    });
    return numberFormat(total);
  };

  const calculateTotalFact = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      e.createdOrder.products.forEach((e) => {
        total += e.amount * e.price;
      });
    });
    return numberFormat(total);
  };

  const calculateTotalAmount = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      total += e.amountPayment * 1;
    });
    return numberFormat(total);
  };

  const calculateTotalDiscount = (data) => {
    let total = 0;
    if (!data) return 0;
    data.forEach((e) => {
      total += e.discount * 1;
    });
    return numberFormat(total);
  };

  return data.managers.map((e, i) => {
    const myOrders = data.orders.filter((order) => order.user.id === e.id);
    return (
      <Box key={i}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "background.paper",
            padding: "10px",
            borderBottom: "1px solid #ccc",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                backgroundColor: "rgba(3, 134, 129, 0.22)",
                borderRadius: "50%",
              }}
            >
              <Typography>{i + 1}</Typography>
            </Box>
            <Typography>{e.name}</Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Typography textAlign={"center"}>{myOrders.length}</Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Typography textAlign={"center"} fontWeight={"bold"}>
              {calculateTotalPrice(myOrders)}
            </Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Typography textAlign={"center"} fontWeight={"bold"}>
              {calculateTotalAmount(myOrders)}
            </Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Typography textAlign={"center"} fontWeight={"bold"}>
              {calculateTotalFact(myOrders)}
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Barcha buyurtmalar">
              <Button
                variant="outlined"
                size="small"
                startIcon={<FcSurvey />}
                onClick={async () => {
                  setDialog({
                    open: true,
                    data: [],
                    manager: e,
                  });
                  const res = await request(
                    `/order/user/${e.id}?from=${times.from}&to=${times.to}`,
                    "GET"
                  );
                  setDialog({
                    open: true,
                    data: res.data,
                    manager: e,
                  });
                }}
              >
                Barchasi
              </Button>
            </Tooltip>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Mijozlar bo'yicha buyurtmalar">
              <Button
                variant="outlined"
                size="small"
                startIcon={<FcVoicePresentation />}
                endIcon={<MdArrowForwardIos />}
                onClick={async () => {
                  action("Klient", myOrders);
                }}
              >
                Mijozlar
              </Button>
            </Tooltip>
          </Box>
        </Box>
        <Dialog
          open={dialog.open}
          onClose={() => setDialog({ open: false, data: [], manager: null })}
          fullScreen
        >
          <DialogTitle
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "action.hover",
            }}
          >
            <IconButton
              onClick={() =>
                setDialog({ open: false, data: [], manager: null })
              }
              size="large"
            >
              <MdKeyboardArrowLeft />
            </IconButton>
            <Typography variant="h6">{dialog.manager?.name}</Typography>
            <IconButton
              onClick={() =>
                setDialog({ open: false, data: [], manager: null })
              }
            >
              <MdClose />
            </IconButton>
          </DialogTitle>
          <Box sx={{ padding: "10px" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "rgba(3, 134, 129, 0.22)",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                Jami Summasi:
                {calculateTotalPrice(dialog.data)}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "rgba(3, 134, 129, 0.22)",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                Jami Faktura:
                {calculateTotalFact(dialog.data)}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "rgba(245, 158, 11, 0.22)",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                Jami To'lov:
                {calculateTotalAmount(dialog.data)}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "rgba(239, 68, 68, 0.22)",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                Jami Chegirma:
                {calculateTotalDiscount(dialog.data)}
              </Typography>
            </Box>
            {dialog.data.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Trades defaultRows={dialog.data} />
            )}
          </Box>
        </Dialog>
      </Box>
    );
  });
};

export default ManagerComponent;
